__turbopack_context__.v({
  "backButton": "header-module-sass-module__EPQM8W__backButton",
  "header": "header-module-sass-module__EPQM8W__header",
  "userIcon": "header-module-sass-module__EPQM8W__userIcon",
  "userInfoCopy": "header-module-sass-module__EPQM8W__userInfoCopy",
});
